// extracted by mini-css-extract-plugin
export default {"tool":"LCI9oQ4vhQ","tools":"UcjR_eazxB"};